module.exports = __webpack_public_path__ + "static/scale-model-of-busch-gardens-serengeti-safari-in-tampa-florida-8580162ea2f28f06aaecee3b78d95013.png";